<template>
  <div>
    <el-alert
        title="【名称】是每个题块的显示标题，例如单选/多项/填空/简答，不能重复"
        type="info"
        v-if="lock_flag===false"
    >
    </el-alert>
    <el-alert
        title="【客观题】的选项格式样例：A,B,C,D，选项和选项之间使用半角','分开"
        type="info"
        v-if="lock_flag===false"
    >
    </el-alert>
    <el-alert
        title="【主观题】的图片选项：【独立】模式要求题块内没个题目都单独拍照，【合并】模式要求题块内所有题目一起拍照"
        type="info"
        v-if="lock_flag===false"
    >
    </el-alert>
    
    <el-form inline size="mini" style="text-align: left" v-if="lock_flag===false">
      <el-form-item label="名称">
        <el-input v-model="question_group_form.label" placeholder="单选题" style="width: 100px"/>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="question_group_form.group_type" placeholder="请选择" style="width: 100px">
          <el-option
              label="客观题"
              value="choice">
          </el-option>
          <el-option
              label="主观题"
              value="subjective">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选项" v-show="question_group_form.group_type==='choice'">
        <el-input v-model="question_group_form.choices" placeholder="格式:A,B,C,D" style="width: 120px"/>
      </el-form-item>
      <el-form-item label="图片" v-show="question_group_form.group_type==='subjective'">
        <el-select v-model="question_group_form.mode" placeholder="请选择" style="width: 100px">
          <el-option
              label="独立"
              value="s">
          </el-option>
          <el-option
              label="合并"
              value="m">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="评分" v-show="question_group_form.mode==='m'">
        <el-select v-model="question_group_form.police" placeholder="请选择" style="width: 80px">
          <el-option
              label="单评"
              value="s">
          </el-option>
          <el-option
              label="多评"
              value="m">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="阈值" v-if="question_group_form.police==='m'">
        <el-input-number v-model="question_group_form.police_val" :precision="1" :step="0.1"
                         style="width: 100px"></el-input-number>
      </el-form-item>
      <el-form-item label="说明">
        <el-input v-model="question_group_form.describe" placeholder="每题1分" style="width: 120px"/>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-plus" type="primary" size="mini" @click="add_question_group">添加题块</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="answer_table" size="mini" empty-text="请添加题块"
              border highlight-current-row
              ref="answer_table">
      <el-table-column
          prop="label"
          label="名称">
      </el-table-column>
      <el-table-column
          label="类型">
        <template slot-scope="scope">
          <template v-if="scope.row.group_type==='choice'">客观题</template>
          <template v-else>主观题</template>
        </template>
      </el-table-column>
      <el-table-column
          label="选项/模式">
        <template slot-scope="scope">
          <template v-if="scope.row.group_type==='choice'">
            {{get_choices(scope.row.choices)}}
          </template>
          <template v-else>
            <template v-if="scope.row.mode==='s'">
              独立
            </template>
            <template v-else>
              合并
            </template>
          </template>
        </template>
      </el-table-column>
      <el-table-column
          prop="describe"
          label="说明">
      </el-table-column>
      <el-table-column
          label="操作">
        <template slot-scope="scope">
          <template v-if="lock_flag===false">
            <el-button size="mini" type="primary" @click="edit_question_group(scope.$index)">编辑</el-button>
            <el-button size="mini" type="danger" @click="delete_question_group(scope.$index)">删除</el-button>
          </template>
          <template v-else>
            <el-button size="mini" type="primary" @click="edit_question_group(scope.$index)">查看</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div v-show="current_question_group.group_type">
      <el-divider></el-divider>
      <el-alert
          title="【题号】是每个小题的显示标题，在同一题块内不能重复"
          type="info" v-if="lock_flag===false"
      >
      </el-alert>
      <el-alert
          title="【打分项数】表示可选择打分的值，值为2时，可打分的值即为最低分和最高分"
          type="info" v-if="lock_flag===false"
      >
      </el-alert>
      <el-alert
          title="批量添加时根据【题号】自动添加，在题号后加1,2,3,4后缀"
          type="info" v-if="lock_flag===false"
      >
      
      </el-alert>
      <template v-if="lock_flag===false">
        <h3>编辑题块【<span style="color: red">{{current_question_group.label}}</span>】</h3></template>
      <template v-else>
        <h3>题块【<span style="color: red">{{current_question_group.label}}</span>】</h3>
      </template>
      <el-form inline size="mini" style="text-align: left" v-if="lock_flag===false">
        <el-form-item label="名称">
          <el-input v-model="current_question_group.label" placeholder="单选题" style="width: 100px"
                    @change="check_label"/>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="current_question_group.group_type" placeholder="请选择" style="width: 100px"
                     @change="check_type" :disabled="true">
            <el-option
                label="客观题"
                value="choice">
            </el-option>
            <el-option
                label="主观题"
                value="subjective">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选项" v-show="current_question_group.group_type==='choice'">
          <el-input v-model="current_question_group.choices" placeholder="格式:A,B,C,D" style="width: 120px"
                    @change="check_choice"/>
        </el-form-item>
        <el-form-item label="图片" v-show="current_question_group.group_type==='subjective'">
          <el-select v-model="current_question_group.mode" placeholder="请选择" style="width: 100px">
            <el-option
                label="独立"
                value="s">
            </el-option>
            <el-option
                label="合并"
                value="m">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="说明">
          <el-input v-model="current_question_group.describe" placeholder="每题1分" style="width: 120px"/>
        </el-form-item>
        <template v-if="current_question_group.mode==='m'&&current_question_group.group_type==='subjective'">
          <el-form-item label="评分">
            <el-select v-model="current_question_group.police" placeholder="请选择" style="width: 80px">
              <el-option
                  label="单评"
                  value="s">
              </el-option>
              <el-option
                  label="多评"
                  value="m">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="阈值" v-if="current_question_group.police==='m'">
            <el-input-number v-model="current_question_group.police_val" :precision="1" :step="0.1"
                             style="width: 100px"></el-input-number>
          </el-form-item>
        </template>
      </el-form>
      <hr v-if="lock_flag===false">
      <el-form inline size="mini" style="text-align: left" v-if="lock_flag===false">
        <el-form-item label="单题添加：题号">
          <el-input v-model="question_form.label" placeholder="题号" style="width: 80px"/>
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="question_form.describe" placeholder="说明" style="width: 100px"/>
        </el-form-item>
        <el-form-item label="最低">
          <el-input-number v-model="question_form.min_score" :precision="1" :step="0.1"
                           style="width: 100px" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="最高">
          <el-input-number v-model="question_form.max_score" :precision="1" :step="0.1"
                           style="width: 100px" controls-position="right"></el-input-number>
        </el-form-item>
        <template v-if="current_question_group.group_type==='choice'">
          <el-form-item label="单选">
            <el-switch v-model="question_form.single_check"></el-switch>
          </el-form-item>
        </template>
        <template v-if="current_question_group.mode==='s'&&current_question_group.group_type==='subjective'">
          <el-form-item label="评分">
            <el-select v-model="question_form.police" placeholder="请选择" style="width: 80px">
              <el-option
                  label="单评"
                  value="s">
              </el-option>
              <el-option
                  label="多评"
                  value="m">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="阈值" v-if="question_form.police==='m'">
            <el-input-number v-model="question_form.police_val" :precision="1" :step="0.1"
                             style="width: 100px" controls-position="right"></el-input-number>
          </el-form-item>
        </template>
        <el-form-item label="打分项数">
          <el-input-number v-model="question_form.score_step" :step="1"
                           style="width: 100px" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-plus" type="primary" size="mini" @click="add_question">确定</el-button>
        </el-form-item>
      </el-form>
      <hr v-if="lock_flag===false">
      <el-form inline size="mini" style="text-align: left" v-if="lock_flag===false">
        <el-form-item label="批量添加：起始">
          <el-input-number v-model="batch_start" :step="1" :min="0" style="width: 100px"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number v-model="batch_count" :step="1" :min="2" style="width: 100px;"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-plus" type="primary" size="mini" @click="add_question_batch">确定</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="current_question_group.questions" size="mini" empty-text="请添加小题"
      >
        <el-table-column
            prop="label"
            label="题号">
        </el-table-column>
        
        <el-table-column
            prop="min_score"
            label="最低分">
        </el-table-column>
        <el-table-column
            prop="max_score"
            label="最高分">
        </el-table-column>
        <el-table-column
            label="可用打分项">
          <template slot-scope="scope">
            {{get_scores(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column
            label="单选" v-if="current_question_group.group_type==='choice'&lock_flag===false">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.single_check" :disabled="lock_flag===true"></el-switch>
          </template>
        </el-table-column>
        <el-table-column
            prop="describe"
            label="说明">
        </el-table-column>
        <el-table-column
            label="操作" v-if="lock_flag===false">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="delete_question(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ExamForm",
    data() {
      return {
        batch_count: 2,
        batch_start: 1,
        current_question_group: [],
        question_group_form: {
          label: "",
          label_back: "",
          group_type: "choice",
          choices: "",
          describe: "",
          questions: [],
          mode: "s",
          img_src: "",
          police: "s",
          police_val: 2,
        },
        question_form: {
          police: "s",
          police_val: 2,
          label: "",
          answers: [],
          img_src: "",
          describe: "",
          min_score: 0,
          max_score: 0,
          score_step: 2,
          single_check: true
        },
      }
    },
    props: ["answer_table", "lock_flag"],
    methods: {
      check_label(v) {
        let count = 0
        for (let _question_group of this.answer_table) {
          if (_question_group.label === v) {
            count = count + 1
          }
        }
        if (count > 1) {
          this.$alert('题块名称重复', '提示', {
            confirmButtonText: '确定',
          });
          this.current_question_group.label = this.current_question_group.label_back
        } else {
          this.current_question_group.label_back = v
        }
      },
      check_type() {
        this.current_question_group.questions = []
      },
      check_choice() {
        if (this.current_question_group.group_type === "choice") {
          let choices = this.current_question_group.choices.split(",")
          if (choices.length < 2) {
            this.$alert('根据说明格式输入选项', '提示', {
              confirmButtonText: '确定',
            });
            return
          } else {
            this.current_question_group.choices = choices
          }
        } else {
          this.current_question_group.choices = ""
        }
        this.current_question_group.questions = []
      },
      delete_question_group(i) {
        this.answer_table.splice(i, 1);
        this.$nextTick(() => {
          this.current_question_group = []
        })
      },
      delete_question(i) {
        this.current_question_group.questions.splice(i, 1);
      },
      add_question_batch() {
        let question = JSON.parse(JSON.stringify(this.question_form))
        if (question.max_score <= question.min_score) {
          this.$alert('请输入合法的分值', '提示', {
            confirmButtonText: '确定',
          });
          return
        }
        this.current_question_group.questions = []
        for (let i = this.batch_start; i < this.batch_start + this.batch_count; i++) {
          let _question = JSON.parse(JSON.stringify(this.question_form))
          if (this.current_question_group.group_type === 'choice') {
            _question.answers = new Array(this.current_question_group.choices.length).fill(false)
          }
          _question.label = _question.label + i
          this.current_question_group.questions.push(_question)
        }
      },
      add_question() {
        let question = JSON.parse(JSON.stringify(this.question_form))
        if (this.current_question_group.group_type === 'choice') {
          question.answers = new Array(this.current_question_group.choices.length).fill(false)
        }
        if (question.label.length < 1) {
          this.$alert('题号不能为空', '提示', {
            confirmButtonText: '确定',
          });
        } else if (question.max_score <= question.min_score) {
          this.$alert('请输入合法的分值', '提示', {
            confirmButtonText: '确定',
          });
        } else {
          this.current_question_group.questions.push(question)
        }
      },
      add_question_group() {
        let question_group = JSON.parse(JSON.stringify(this.question_group_form))
        for (let _question_group of this.answer_table) {
          if (question_group.label === _question_group.label) {
            this.$alert('题块名称重复', '提示', {
              confirmButtonText: '确定',
            });
            return
          }
        }
        question_group.label_back = question_group.label
        if (question_group.label.length < 2) {
          this.$alert('题块名称不能为空', '提示', {
            confirmButtonText: '确定',
          });
          return
        }
        if (question_group.group_type === "choice") {
          let choices = question_group.choices.split(",")
          if (choices.length < 2) {
            this.$alert('根据说明格式输入选项', '提示', {
              confirmButtonText: '确定',
            });
            return
          } else {
            question_group.choices = choices
          }
        } else {
          question_group.choices = ""
        }
        this.answer_table.push(question_group)
        this.$refs.answer_table.setCurrentRow(this.answer_table[this.answer_table.length - 1]);
        this.current_question_group = this.answer_table[this.answer_table.length - 1]
      },
      edit_question_group(i) {
        this.current_question_group = this.answer_table[i]
      },
      get_scores(row) {
        let s = row.min_score
        let e = row.max_score
        let step = row.score_step
        let step_v = (e - s) / (step - 1)
        let out = []
        if (step < 3) {
          out = [s, e]
        } else {
          for (let i = 0; i < step - 1; i++) {
            out.push(s + step_v * i)
          }
          out.push(e)
        }
        return out
      },
      get_choices(choices) {
        try {
          return choices.join(',')
        } catch (e) {
          return choices
        }
      },
    }
  }
</script>

<style>
  .el-table__row.current-row {
    font-weight: bold;
    color: red;
    font-size: larger;
  }
</style>